import { render, staticRenderFns } from "./configBatchAuth.vue?vue&type=template&id=60c38b01&scoped=true"
import script from "./configBatchAuth.vue?vue&type=script&lang=js"
export * from "./configBatchAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c38b01",
  null
  
)

export default component.exports